import { JsonObject, JsonProperty } from 'json2typescript';

import { ConceptInterface } from '../../../core';

@JsonObject('Concept')
export class Concept implements ConceptInterface {
    @JsonProperty('Concept', String, true)
    private _concept: string = undefined;

    @JsonProperty('Definition', String, true)
    private _definition: string = undefined;

    get concept(): string {
        return this._concept;
    }

    get definition(): string {
        return this._definition;
    }
}
